import React from 'react';
import { Box } from '@sparrowengg/twigs-react';
import Navbar from 'commons/components/navbar';
import AppReleaseRequests from 'features/apps/release-requests/components';

const AppReleaseRequestsPage = () => {
  return (
    <Box css={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <Navbar showPreviousBtn />
      <AppReleaseRequests />
    </Box>
  );
};

export default AppReleaseRequestsPage;
